import React, { useEffect, useState, useCallback, useRef } from 'react';
import { Container, Box, Typography, Card, CardContent, Grid, Modal, Avatar, IconButton, Button, LinearProgress } from '@mui/material';
import logo_between from '../../../../public/assets/logo-white.jpeg';
import CloseIcon from '@mui/icons-material/Close';
import LeadService from '../../../core/services/leadsService';
import { RiArrowDropDownLine } from 'react-icons/ri';
import { BsTelephoneFill } from 'react-icons/bs';
import { MdEmail } from 'react-icons/md';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';
import { useNavigate } from 'react-router-dom';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import toast from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import user_icon from '../../../../public/assets/user_icon.jpg';
import { makeStyles } from '@mui/styles';
import { CLOSE_LEAD_COM_MODEL, OPEN_INVITE_MODEL, OPEN_RE_ASSING_MODAL } from '../../../core/store/slice/icaSlice';
import AddIcon from '@mui/icons-material/Add';
import NoteAltIcon from '@mui/icons-material/NoteAlt';
import RemoveIcon from '@mui/icons-material/Remove';
import ChatModule from '../CustomerLeadProfile/ChatModule';
import LogoutExpiredModal from '../../LogoutExpiredModal';
import Pagination from '@mui/material/Pagination';
import { debounce, throttle } from 'lodash';
import Autocomplete from '@mui/material/Autocomplete';
import { Chip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import UpdateIcaMeeting from '../ICaMap/UpdateIcaMeeting';
import FilterListIcon from '@mui/icons-material/FilterList';
import Divider from '@mui/material/Divider';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import { GlobalStyles } from '@mui/system';
import { ThemeProvider } from '@mui/material/styles';
import { useTheme } from '@mui/material/styles';
import CheckIcon from '@mui/icons-material/Check';
const useStyles = makeStyles({
    card: {
        width: 720,
        height: 'auto',
        borderRadius: '20px !important',
        boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
        backgroundColor: '#84ADD6 !important',
    },
    cardOne: {
        width: 720,
        height: 'auto',
        borderRadius: '8px !important',
        backgroundColor: '#84ADD6 !important',
        boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
    },
});
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
    '& .MuiDialog-paper': {
        borderRadius: '20px', // Set your desired border radius here
    },
}));
const ICALEADS = () => {
    const classes = useStyles();
    const navigate = useNavigate();
    const theme = useTheme();
    const [leads, setLeads] = useState([]);
    const [LeadsDetails, setLeadsDetails] = useState();
    const [loading, setLoading] = useState(true);
    const [filterLoading, setFilterLoading] = useState(false);
    const [LeadId, setLeadId] = useState(null);
    const [notes, setNotes] = useState();
    const [updateStatusNotes, newUpdateStatusNotes] = useState('');
    const [updateStatusValue, newUpdateStatusValue] = useState('');
    const [zoomLevel, setZoomLevel] = useState(13);
    const [displayNotes, setDisplayNotes] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const { user } = useSelector((state) => state.auth);
    const [logOutModal, setLogOutModal] = useState(false);
    const [saveNoteModel, setSaveNoteModel] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [selectedFilterValue, setSelectedFilterValue] = useState('');
    const [saveNoteStatus, setSaveNoteModelStatus] = useState('');
    const [openMeetingModal, setOpenMeetingModal] = useState(false);
    const [loadingModal, setLoadingModal] = useState(false);
    const [sortOrder, setSortOrder] = useState('asc');
    const [menuAnchor, setMenuAnchor] = useState(null);
    const [sortOrderLeads, setSortOrderLeads] = useState('asc');
    const [menuAnchorLeads, setMenuAnchorLeads] = useState(null);
    const [showAllReplies, setShowAllReplies] = React.useState(false);
    const { leadComModal } = useSelector((state) => state.ica);
    const abortControllerRef = useRef(null);
    const userData = JSON.parse(localStorage.getItem('user'));
    const LoginId = userData?.user.id;
    const menuItems = [
        { value: 'active', text: 'Active' },
        { value: 'new', text: 'New' },
        { value: 'attempting_contact', text: 'Attempting Contact' },
        { value: 'spoke_with_customer_new', text: 'Spoke with customer New' },
        { value: 'spoke_with_customer', text: 'Spoke with customer' },
        { value: 'appointment_set', text: 'Appointment Set' },
        { value: 'met_with_customer', text: 'Met with customer' },
        { value: 'showing_homes', text: 'Showing Homes' },
        { value: 'submitting_offers', text: 'Submitting Offers' },
        { value: 'under_contract_escrow', text: 'Under Contract/Escrow' },
        { value: 'bamfam', text: 'BAMFAM' },
        { value: 'nurture', text: 'Nurture Before sale' },
        { value: 'nurture_after_sale', text: 'Nurture After Sale' },
        { value: 'closed', text: 'Sale Closed' },
        { value: 'rejected', text: 'Rejected' },
        { value: 'not_interested', text: 'Not Interested' },
        { value: 'refinance_referral', text: 'Refinance Referral' },
        { value: 'personal_lead', text: 'Personal Lead' },
        { value: 'agent', text: 'Agent' },
        { value: 'bad_lead', text: 'Bad Lead' },
        { value: 'buy_side_contract', text: 'Buy Side Contract' },
        { value: 'dnc', text: 'DNC' },
        { value: 'buyer_broker_signed', text: 'Buyer Broker Signed' },
        { value: 'cancelled', text: 'Cancelled' },
        { value: 'valuation_appointment', text: 'Valuation Appointment' },
        { value: 'listing_signed', text: 'Listing Signed' },
        { value: 'listing_appointment', text: 'Listing Appointment' },
        { value: 'follow_up', text: 'Follow Up' },
        { value: 'list_under_contract', text: 'List Under Contract' },
    ];

    const filterLeads = [
        { label: 'All Leads', value: '' },
        { label: 'Invited Leads', value: 'invited' },
        { label: 'Assigned Leads', value: 'appointment_set' },
    ];

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const GetIcaLeadNotes = async (LeadId) => {
        try {
            const res = await LeadService.GetLeadNote(LeadId);
            if (res?.data?.success) {
                const formattedNotes = res?.data?.notes.map((note) => {
                    return {
                        id: note?.id,
                        content: note?.note,
                        creatorName: note?.creatorName,
                        createTime: note?.created_at,
                        replies: note?.replies || [],
                    };
                });
                setDisplayNotes(formattedNotes);
            }
        } catch (error) {
            console.error(error.message);
            toast.error(error.message);
        }
    };
    const handleUpdateStatus = async (value) => {
        setAnchorEl(null);
        const Lead_id = LeadsDetails.id;
        const LoginUserId = user.id;
        const newUpdateStatusFrontEnd = menuItems.find((item) => item.value === value)?.text || '';
        newUpdateStatusNotes(newUpdateStatusFrontEnd);
        newUpdateStatusValue(value);
        const appointmentSet = LeadsDetails.appointment_set;
        const status = LeadsDetails.status;
        const selectedPropertiesId = LeadsDetails?.id;
        if (status === 'rejected' || (status === 'closed' && value === 'appointment_set')) {
            return toast.error("Rejection of Update status.You can't proceed further!.");
        } else if (appointmentSet == 0) {
            return toast.error("You can't update any status without assigning to real estate agent!.");
        } else if (appointmentSet == 1 && value === 'appointment_set') {
            return toast.error('The status is already Assigned');
        } else if (value === 'appointment_set') {
            return toast.error('The status is already Assigned.');
        } else if (status === value) {
            return toast.error('Select another status and proceed later!');
        } else if (status === 'rejected') {
            return toast.error("Rejection of Update status.You can't proceed further!.");
        } else if (status === 'closed') {
            return toast.error("Rejection of Update status.You can't proceed further!.");
        } else {
            const note = `has changed status from "${formattedStatus.props.children}" to "${updateStatusNotes}" with this note "${saveNoteStatus}"`;
            if (!saveNoteModel) {
                setSaveNoteModel(true);
            } else {
                if (!saveNoteStatus.trim()) {
                    return toast.error('Please add a note for complete customer profile details.');
                }
                setSaveNoteModel(false);
                await NewUpdateStatus(value, Lead_id, LoginUserId, selectedPropertiesId, note, updateStatusValue);
            }
        }
    };

    const NewUpdateStatus = async (updateStatusValue, Lead_id, LoginUserId, selectedPropertiesId, note) => {
        try {
            const res = await LeadService.updateStatus(updateStatusValue, Lead_id, LoginUserId);
            if (res?.data?.success) {
                toast.success(res?.data?.message);
                await handleAgentInternalNote(selectedPropertiesId, note);
                await getLeadDetails(LeadId);
                await IcaLeadsAgent();
                setSaveNoteModelStatus('');
                return;
            }
        } catch (error) {
            console.error(error.message);
            toast.error(error.message);
        }
    };
    const IcaLeadsAgent = async (currentPage, selectedFilterValue = '') => {
        try {
            setFilterLoading(true);
            const res = await LeadService.icaLeads(currentPage, selectedFilterValue);
            if (res?.data?.success) {
                setLeads(res?.data?.assign_leads?.data);
                setCurrentPage(res?.data?.assign_leads?.current_page || 1);
                setTotalPages(Math.ceil((res?.data?.assign_leads?.total || 0) / (res?.data?.assign_leads?.per_page || 1)));

                if (res?.data?.assign_leads?.data?.length === 0) {
                    return toast.success('No data found!');
                }
                return;
            }
        } catch (error) {
            if (error.message === 'You have been logged out of the application, please login again to use the application.') {
                setLogOutModal(true);
            } else {
                toast.error(error.message);
            }
        } finally {
            setLoading(false);
            setFilterLoading(false);
        }
    };
    const throttledGetLeads = useCallback(
        throttle((currentPage, selectedFilterValue, signal) => {
            IcaLeadsAgent(currentPage, selectedFilterValue, signal);
        }, 2000),
        []
    );

    const fetchIcaLeadsAgent = useCallback(
        debounce((currentPage, selectedFilterValue) => {
            if (abortControllerRef.current) {
                abortControllerRef.current.abort();
            }
            const abortController = new AbortController();
            abortControllerRef.current = abortController;
            throttledGetLeads(currentPage, selectedFilterValue, abortController.signal);
        }, 300),
        [throttledGetLeads]
    );
    useEffect(() => {
        fetchIcaLeadsAgent(currentPage, selectedFilterValue);
    }, [currentPage, selectedFilterValue]);

    useEffect(() => {
        if (LeadsDetails?.note?.notes) {
            setDisplayNotes(LeadsDetails?.note?.notes);
        }
    }, [LeadsDetails]);

    const handleDisplayNotes = () => {
        if (notes) {
            const currentDate = new Date();
            const month = currentDate.toLocaleString('en-US', {
                month: '2-digit',
            });
            const day = currentDate.toLocaleString('en-US', {
                day: '2-digit',
            });
            const year = currentDate.toLocaleString('en-US', {
                year: 'numeric',
            });
            const time = currentDate.toLocaleString('en-US', {
                hour: '2-digit',
                minute: '2-digit',
                hour12: true,
            });
            const formattedTimestamp = `${month}-${day}-${year} ${time} `;

            const newNote = {
                content: notes,
                creatorName: `${LeadsDetails?.assignby?.name || ''} ${LeadsDetails?.assignby?.last_name || ''}`,
                createTime: new Date().toISOString(),
                timestamp: formattedTimestamp,
            };
            setDisplayNotes([...displayNotes, newNote]);
            setNotes('');
        }
    };

    const handleAgentInternalNote = async (selectedPropertiesId, note) => {
        try {
            handleDisplayNotes();
            const currentDate = new Date();
            const month = currentDate.toLocaleString('en-US', {
                month: '2-digit',
            });
            const day = currentDate.toLocaleString('en-US', {
                day: '2-digit',
            });
            const year = currentDate.toLocaleString('en-US', {
                year: 'numeric',
            });
            const time = currentDate.toLocaleString('en-US', {
                hour: '2-digit',
                minute: '2-digit',
                hour12: true,
            });
            const timestamp = `${month}-${day}-${year} ${time} `;
            const res = await LeadService.icaAgentInternalNote(selectedPropertiesId, note, timestamp);
            if (res?.data?.success === true) {
                toast.success(res?.data?.message);
                return;
            }
        } catch (error) {
            console.error(error);
            toast.error(error.message);
        }
    };
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (leadComModal.open) {
            handleOpen(leadComModal.id);
            setTimeout(() => {
                dispatch(CLOSE_LEAD_COM_MODEL());
            }, 300);
        }
    }, [leadComModal.open]);

    const handleOpen = async (LeadId) => {
        setLeadId(LeadId);
        setLoadingModal(true);
        await setOpen(true);
        await getLeadDetails(LeadId);
        await GetIcaLeadNotes(LeadId);
    };
    const getLeadDetails = async (LeadId) => {
        try {
            const res = await LeadService.getLeadDetails(LeadId);
            if (res?.data?.success) {
                setLeadsDetails(res?.data?.lead);
                return;
            }
        } catch (error) {
            console.error(error);
            if (error.message === 'You have been logged out of the application, please login again to use the application.') {
                setLogOutModal(true);
            } else {
                toast.error(error.message);
            }
        } finally {
            setLoading(false);
            setLoadingModal(false);
        }
    };
    const handleClose = () => setOpen(false);
    const handleCloseModalProperties = () => {
        setOpen(false);
    };
    const dispatch = useDispatch();

    const [showPhoneNumber, setShowPhoneNumber] = useState(false);
    const email = LeadsDetails?.email;
    const gmailComposeUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${email}`;
    const capitalizeFirstLetter = (string) => {
        if (!string) return '';
        return string.charAt(0).toUpperCase() + string.slice(1);
    };
    // Remove underscores from updateStatusValue and capitalize the first letter
    const formattedStatusValue = capitalizeFirstLetter(updateStatusValue.replace(/_/g, ' '));
    const mapStatusToFormatAndColor = (status) => {
        const statusMapping = {
            active: { text: ' ● New ', color: '#00000F' },
            new: { text: ' ● New ', color: '#00000F' },
            attempting_contact: { text: ' ● Attempting Contact ', color: '#9B0000' },
            spoke_with_customer_new: { text: ' ● New ', color: '#00000F' },
            spoke_with_customer: { text: ' ● Spoke with customer ', color: '#00BF2A' },
            appointment_set: { text: ' ● Appointment Set ', color: '#00BF2A' },
            met_with_customer: { text: ' ● Met with customer ', color: '#7400C2' },
            showing_homes: { text: ' ● Showing Homes ', color: '#ED7DB1' },
            submitting_offers: { text: ' ● Submitting Offers ', color: '#6EA478' },
            under_contract_escrow: { text: ' ● Under Contract/Escrow ', color: '#4C489B' },
            bamfam: { text: ' ● BAMFAM ', color: '#6691CB' },
            nurture: { text: ' ● Nurture Before sale ', color: '#9B5B00' },
            nurture_after_sale: { text: ' ● Nurture After Sale ', color: '#9B5B5B' },
            closed: { text: ' ●  Sale Closed ', color: '#F17105' },
            rejected: { text: ' ● Rejected ', color: '#ED0423' },
            not_interested: { text: ' ● Not Interested ', color: '#ebc3c3' },
            refinance_referral: { text: ' ● Refinance Referral ', color: '#9B5B5B' },
            personal_lead: { text: ' ● Personal Lead ', color: '#9B5B5B' },
            agent: { text: ' ● Agent ', color: 'white' },
            bad_lead: { text: ' ● Bad Lead ', color: '#2e1414' },
            buy_side_contract: { text: ' ● Buy Side Contract ', color: '#9B5B5B' },
            dnc: { text: ' ● DNC ', color: '#9B5B5B' },
            buyer_broker_signed: { text: ' ● Buyer Broker Signed ', color: '#FFFFFF' },
            cancelled: { text: ' ● Cancelled ', color: '#FFFFFF' },
            valuation_appointment: { text: ' ● Valuation Appointment ', color: '#FFFFFF' },
            listing_signed: { text: ' ● Listing Signed ', color: '#FFFFFF' },
            listing_appointment: { text: ' ● Listing Appointment ', color: '#FFFFFF' },
            follow_up: { text: ' ● Follow Up ', color: '#FFFFFF' },
        };

        const divBackgroundColors = {
            active: '#e9e4e4',
            new: '#e9e4e4',
            attempting_contact: '#ababef',
            spoke_with_customer_new: '#ababef',
            spoke_with_customer: '#bee5c6',
            appointment_set: '#bee5c6',
            met_with_customer: '#d9c2e9',
            showing_homes: '#f9d5e6',
            submitting_offers: '#bbe3c2',
            under_contract_escrow: '#c1bfed',
            bamfam: '#edeff5',
            nurture: '#f9deb8',
            nurture_after_sale: '#e7c612',
            closed: '#fff0e3',
            rejected: '#fbdfe2',
            not_interested: '#df3271',
            refinance_referral: '#e7e2c7',
            agent: '#5500CC',
            personal_lead: '##fff',
            bad_lead: '#c12f0d',
            buy_side_contract: '#e7c612',
            dnc: '#A87BFF',
            buyer_broker_signed: '#FABED4',
            cancelled: '#4C489B',
            valuation_appointment: '#7D9B00',
            listing_signed: '#C29800',
            listing_appointment: '#CB5935',
            follow_up: '#2e7a5c',
        };
        const divBorder = {
            active: '1px solid black',
            new: '1px solid black',
            attempting_contact: '1px solid #9B0000',
            spoke_with_customer_new: '1px solid #00000F',
            spoke_with_customer: '1px solid #00BF2A',
            appointment_set: '1px solid #00BF2A',
            met_with_customer: '1px solid #7400C2',
            showing_homes: '1px solid #ED7DB1',
            submitting_offers: '1px solid #6EA478',
            under_contract_escrow: '1px solid #4C489B',
            bamfam: '1px solid #6691CB',
            nurture: '1px solid #9B5B00',
            nurture_after_sale: '1px solid #9B5B5B',
            closed: '1px solid #F17105',
            rejected: '1px solid #ED0423',
            not_interested: '1px solid #a9199f',
            refinance_referral: '1px solid #a99497',
            agent: '1px solid #5500CC',
            personal_lead: '1px solid #a99497',
            bad_lead: '1px solid #5c433b',
            buy_side_contract: '1px solid #9B5B5B',
            dnc: '1px solid #9B5B5B',
            buyer_broker_signed: '1px solid #FABED4',
            cancelled: '1px solid #4C489B',
            valuation_appointment: '1px solid #7D9B00',
            listing_signed: '1px solid #483c10',
            listing_appointment: '1px solid #CB5935',
            follow_up: '1px solid #2d6f55',
        };

        const { text, color } = statusMapping[status] || { text: status, color: '#000000' };
        const divBackgroundColor = divBackgroundColors[status] || 'transparent';
        const border = divBorder[status] || '1px solid black';
        return {
            formattedStatus: <span style={{ color }}>{text}</span>,
            divStyle: {
                background: divBackgroundColor,
                border,
            },
        };
    };
    const { formattedStatus, divStyle } = mapStatusToFormatAndColor(LeadsDetails?.status);
    const handleClickNavigateModel = async (data) => {
        navigate('/map');
        dispatch(OPEN_RE_ASSING_MODAL(data));
        // stopGetLeads();
    };

    const handleZoomIn = () => {
        setZoomLevel((prevZoom) => prevZoom + 1);
    };

    const handleZoomOut = () => {
        setZoomLevel((prevZoom) => Math.max(1, prevZoom - 1));
    };

    const formatDate = (timestamp) => {
        const date = new Date(timestamp);
        const formattedDate = `${date.toLocaleDateString()} ${date.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })}`;
        return formattedDate;
    };
    const handleNoteModalClose = async () => {
        setSaveNoteModel(false);
        await getLeadDetails(LeadId);
    };

    const adjustTimeBasedOnOffsetForReceivedData = (date, offsetInHours) => {
        const adjustedDate = new Date(date);
        adjustedDate.setHours(adjustedDate.getHours() + offsetInHours);
        return adjustedDate;
    };

    const getUserOffset = () => {
        const offset = localStorage.getItem('userOffset');
        return offset ? parseFloat(offset) : 0;
    };

    const formatDateTime = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        let hours = date.getHours();
        const minutes = String(date.getMinutes()).padStart(2, '0');

        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12;
        hours = String(hours).padStart(2, '0');

        return `${year}-${month}-${day} ${hours}:${minutes} ${ampm}`;
    };

    const handleClickOpenMeetingModel = () => {
        // stopGetLeads()
        setOpenMeetingModal(true);
        setOpen(false);
    };

    const handleSort = (order) => {
        setSortOrder(order);
        const sortedNotes = [...displayNotes].sort((a, b) => {
            return order === 'asc' ? a.creatorName.localeCompare(b.creatorName) : b.creatorName.localeCompare(a.creatorName);
        });
        setDisplayNotes(sortedNotes);
        setMenuAnchor(null);
    };

    const tagsOne = LeadsDetails?.tag ? LeadsDetails.tag.split(', ') : [];
    const format12HourTime = (timeString) => {
        if (!timeString) return '';
        let dateObj = new Date(timeString);
        if (isNaN(dateObj.getTime())) {
            const today = new Date();
            const [hours, minutes] = timeString.split(':');
            dateObj = new Date(today.getFullYear(), today.getMonth(), today.getDate(), hours, minutes);
        }

        return dateObj.toLocaleString('en-US', {
            hour: 'numeric',
            minute: 'numeric',
            hour12: true,
        });
    };

    const handleSortLeads = (order) => {
        setSortOrderLeads(order);

        const sortedLeads = [...leads].sort((a, b) => {
            const nameA = a.lead?.first_name?.toLowerCase() || '';
            const nameB = b.lead?.first_name?.toLowerCase() || '';

            if (order === 'asc') {
                return nameA.localeCompare(nameB);
            } else {
                return nameB.localeCompare(nameA);
            }
        });

        setLeads(sortedLeads);
        setMenuAnchorLeads(null);
    };

    return (
        <Container>
            <LinearProgress sx={{ visibility: filterLoading ? '' : 'hidden', marginBottom: '12px' }} />
            <ThemeProvider theme={theme}>
                <GlobalStyles
                    styles={{
                        '::-webkit-scrollbar': {
                            width: '14px', // Set the desired width for the scrollbar
                        },
                        '::-webkit-scrollbar-thumb': {
                            backgroundColor: '#c1c1c1', // Set the color for the scrollbar thumb
                            borderRadius: '10px', // Set the border radius for a rounded effect
                        },
                    }}
                />
                {/*Lead Details Modal */}
                <>
                    {loadingModal ? (
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                position: 'absolute',
                                zIndex: '50',
                                transform: 'translate(-50%, -50%)',
                                top: '50%',
                                left: '50%',
                            }}
                        >
                            <CircularProgress sx={{ color: 'red' }} />
                        </div>
                    ) : (
                        <BootstrapDialog aria-labelledby="customized-dialog-title" open={open}>
                            <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                                Lead Details
                            </DialogTitle>
                            <IconButton
                                aria-label="close"
                                onClick={handleClose}
                                sx={(theme) => ({
                                    position: 'absolute',
                                    right: 8,
                                    top: 8,
                                    color: theme.palette.grey[500],
                                })}
                            >
                                <CloseIcon />
                            </IconButton>

                            <DialogContent dividers>
                                <div>
                                    <div style={{ marginTop: '0px', position: 'relative' }}>
                                        <Box>
                                            {/* google image */}
                                            <img
                                                src={`https://maps.googleapis.com/maps/api/staticmap?zoom=${zoomLevel}&size=720x220&maptype=roadmap&center=${LeadsDetails?.buyer_latitude},${LeadsDetails?.buyer_longitude}&key=AIzaSyC9saN_UXZFij-RjWWX9drQEQSZw5PaPcA`}
                                                alt="Static map"
                                                style={{
                                                    width: '720px',
                                                    height: '220px',
                                                    borderRadius: '22px',
                                                    boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                                }}
                                            />
                                            <div
                                                style={{
                                                    position: 'absolute',
                                                    top: 4,
                                                    right: 19,
                                                    // display: 'flex', flexDirection: 'column'
                                                }}
                                            >
                                                <Button
                                                    onClick={handleZoomIn}
                                                    variant="outlined"
                                                    style={{ fontSize: '12px', fontWeight: '600', background: 'white', color: 'black' }}
                                                >
                                                    <AddIcon />
                                                </Button>
                                                <Button
                                                    onClick={handleZoomOut}
                                                    variant="outlined"
                                                    style={{ fontSize: '12px', fontWeight: '600', background: 'white', color: 'black' }}
                                                >
                                                    <RemoveIcon />
                                                </Button>
                                            </div>
                                        </Box>
                                        <Box
                                            style={{
                                                position: 'absolute',
                                                top: '53px',
                                                left: '50%',
                                                transform: 'translateX(-50%)',
                                                zIndex: 10,
                                                display: 'flex',
                                                alignItems: 'center',
                                                borderRadius: '4px',
                                                padding: '5px',
                                            }}
                                        >
                                            <img
                                                src={logo_between}
                                                alt=""
                                                style={{ width: '44px', height: '44px', borderRadius: '24px', border: '1px solid gray' }}
                                            />
                                        </Box>
                                    </div>

                                    <div style={{ display: 'flex', marginTop: '15px', justifyContent: 'space-between' }}>
                                        <div style={{ display: 'grid' }}>
                                            <div style={{ display: 'flex', gap: '4px' }}>
                                                <div
                                                    style={{
                                                        marginTop: '1px',
                                                    }}
                                                >
                                                    <Divider
                                                        style={{
                                                            border: LeadsDetails?.assignto?.last_login ? '3px solid green' : '3px solid red',
                                                            backgroundColor: LeadsDetails?.assignto?.last_login ? 'green' : 'red', // Conditionally change background color
                                                            transform: 'rotate(180deg)',
                                                            height: '25px',
                                                            borderRadius: '10px',
                                                        }}
                                                    />
                                                </div>
                                                <div>
                                                    <span style={{ fontSize: '22px', fontWeight: '700', color: '#606060' }}>
                                                        {LeadsDetails?.first_name} {LeadsDetails?.last_name}
                                                    </span>
                                                </div>
                                            </div>

                                            <div style={{ width: '300px', height: 'auto' }}>
                                                <span style={{ fontSize: '12px', color: '#332f2f', fontWeight: '500' }}>
                                                    🏠 : {LeadsDetails?.display_address}
                                                </span>
                                            </div>
                                        </div>
                                        <div style={{ display: 'flex', gap: '5px' }}>
                                            <div
                                                style={{
                                                    ...divStyle,
                                                    borderRadius: '10px',
                                                    padding: '3px',
                                                    width: 'auto',
                                                    display: 'flex',
                                                    gap: '2px',
                                                    marginRight: '-14px',
                                                    height: '41px',
                                                }}
                                            >
                                                <div style={{ marginTop: '3px', cursor: 'pointer' }} onClick={handleClick}>
                                                    {/* <span style={{ color: 'red' }}>{LeadsDetails?.status}</span> */}
                                                    {formattedStatus}
                                                </div>
                                            </div>
                                            <RiArrowDropDownLine
                                                onClick={handleClick}
                                                style={{
                                                    fontSize: '36px',
                                                    cursor: 'pointer',
                                                }}
                                            />
                                            <Menu
                                                id="demo-positioned-menu"
                                                aria-labelledby="demo-positioned-button"
                                                anchorEl={anchorEl}
                                                open={Boolean(anchorEl)}
                                                onClose={() => setAnchorEl(null)}
                                                anchorOrigin={{
                                                    vertical: 'bottom',
                                                    horizontal: 'left',
                                                }}
                                                transformOrigin={{
                                                    vertical: 'top',
                                                    horizontal: 'right',
                                                }}
                                                style={{ height: '300px' }}
                                            >
                                                {menuItems.map((menuItem) => (
                                                    <MenuItem key={menuItem.value} onClick={() => handleUpdateStatus(menuItem.value)}>
                                                        {menuItem.text}
                                                    </MenuItem>
                                                ))}
                                            </Menu>
                                        </div>
                                    </div>
                                    <div>
                                        <span
                                            style={{
                                                fontSize: '12px',
                                                fontWeight: '500',
                                                width: '300px',
                                                height: 'auto',
                                            }}
                                        >
                                            📅 {LeadsDetails?.date} {format12HourTime(LeadsDetails?.time)} @ {LeadsDetails?.meeting_location}
                                        </span>
                                    </div>
                                    <div>
                                        <span
                                            style={{
                                                display: 'block',
                                                fontSize: '12px',
                                                fontWeight: '500',
                                                whiteSpace: 'nowrap',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                            }}
                                        >
                                            {LeadsDetails?.buyer_max_price ? `💵: $${LeadsDetails.buyer_max_price}.00 USD` : '💵: $0.00'} <br />
                                            {LeadsDetails?.created_at ? `📅: ${formatDate(LeadsDetails.created_at)}` : ''}
                                        </span>
                                    </div>
                                    {/* buyer button */}
                                    <div style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
                                        <Button
                                            style={{
                                                width: '162px',
                                                height: '39px',
                                                backgroundColor: 'white',
                                                fontSize: '14px',
                                                borderRadius: '14px',
                                                border: ' 1px solid #587DBF',
                                                color: '#587DBF',
                                            }}
                                        >
                                            ICNT-{LeadsDetails?.id}
                                        </Button>
                                        <div>
                                            <Button
                                                style={{
                                                    width: '127px',
                                                    height: '38px',
                                                    fontSize: '14px',
                                                    backgroundColor: 'white',
                                                    fontWeight: '500',
                                                    borderRadius: '14px',
                                                    border: ' 1px solid #587DBF',
                                                    color: '#587DBF',
                                                }}
                                            >
                                                {LeadsDetails?.lead_type}
                                            </Button>
                                        </div>
                                        <div>
                                            <Button
                                                style={{
                                                    width: 'auto',
                                                    height: '39px',
                                                    backgroundColor: 'white',
                                                    fontSize: '14px',
                                                    borderRadius: '14px',
                                                    border: ' 1px solid #587DBF',
                                                    color: '#587DBF',
                                                }}
                                            >
                                                From {LeadsDetails?.source}
                                            </Button>
                                        </div>
                                    </div>
                                    {/* zillow flex lead */}
                                    <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '30px' }}>
                                        <div style={{ display: 'flex', flexWrap: 'wrap', width: '400px' }}>
                                            <div style={{ flex: 1, width: '250px', marginBottom: '5px' }}>
                                                <div style={{ display: 'flex', gap: '2px', flexWrap: 'wrap' }}>
                                                    {tagsOne.length > 0 ? (
                                                        tagsOne.map((tag, index) => (
                                                            <Chip
                                                                key={index}
                                                                label={tag}
                                                                sx={{
                                                                    border: '1px solid #587dbf',
                                                                    color: '#587dbf',
                                                                    fontSize: '10px',
                                                                    background: 'transparent',
                                                                }} // Add margin for spacing
                                                            />
                                                        ))
                                                    ) : (
                                                        <p></p>
                                                    )}
                                                </div>
                                            </div>
                                        </div>

                                        <div style={{ display: 'flex', gap: '10px' }}>
                                            {showPhoneNumber && <span style={{ marginTop: '10px', fontSize: '12px' }}>{LeadsDetails?.phone}</span>}
                                            {LeadsDetails?.phone !== null && (
                                                <BsTelephoneFill
                                                    style={{ fontSize: '18px', marginTop: '4px', cursor: 'pointer', color: 'black' }}
                                                    onClick={() => setShowPhoneNumber(!showPhoneNumber)}
                                                    title="Click to show phone number"
                                                />
                                            )}
                                            <a href={gmailComposeUrl} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                                                <MdEmail
                                                    style={{ fontSize: '23px', cursor: 'pointer', color: 'black' }}
                                                    title="Compose email in Gmail"
                                                />
                                            </a>
                                        </div>
                                    </div>
                                    {/* {LeadsDetails?.assignto !== null && (
                        <div>
                            <Typography style={{ fontSize: '22px', fontWeight: 'bold' }}>Communication Section</Typography>
                            <Card style={{ width: '720px', borderRadius: '22px', boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px' }}>
                                <CardContent>
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <Box style={{ display: 'grid', gap: '10px' }}>
                                            <Box style={{ display: 'flex', gap: '10px' }}>
                                                <Box>
                                                    <Avatar
                                                        alt="Remy Sharp"
                                                        src={`https://iconnctapp.com/` + LeadsDetails?.assignby?.profile_image}
                                                    />
                                                </Box>
                                                <Box style={{ marginTop: '10px' }}>{LeadsDetails?.assignby?.name} {' '} {LeadsDetails?.assignby?.last_name}</Box>
                                            </Box>

                                            <Box style={{ display: 'flex', gap: '10px' }}>
                                                <Box>
                                                    <Avatar
                                                        src={`https://iconnctapp.com/` + LeadsDetails?.assignto?.profile_image}
                                                    />
                                                </Box>
                                                <Box style={{ marginTop: '10px' }}>{LeadsDetails?.assignto?.name} {' '}{LeadsDetails?.assignto?.last_name}</Box>
                                            </Box>

                                            <Box style={{ display: 'flex', gap: '10px' }}>
                                                <Box>
                                                    <Avatar alt="Remy Sharp" src={logo_between} />
                                                </Box>
                                                <Box style={{ marginTop: '10px' }}>Shaw Tong</Box>
                                            </Box>
                                        </Box>

                                
                                        <Box>
                                            <Box>
                                                <ChatModule
                                                    icaImage={LeadsDetails?.assignby?.profile_image}
                                                    leadImge={LeadsDetails?.assignto?.profile_image}
                                                    leadId={LeadsDetails?.id}
                                                    status={LeadsDetails?.status}
                                                    buyer_latitude={LeadsDetails?.buyer_latitude}
                                                    buyer_longitude={LeadsDetails?.buyer_longitude}
                                                    name={`${LeadsDetails?.first_name} ${LeadsDetails?.last_name}`}
                                                />
                                            </Box>
                                            <Box>
                                                <Typography style={{ fontSize: '18px', color: 'gray', fontWeight: 'bold' }}>Chat Here</Typography>
                                            </Box>
                                        </Box>
                                    </div>
                                </CardContent>
                            </Card>
                        </div>
                    )} */}
                                    {/* Assignment section */}
                                    {LeadsDetails?.assign == 0 ? (
                                        <>
                                            <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'center' }}>
                                                <Button
                                                    onClick={() => handleClickNavigateModel(LeadsDetails)}
                                                    style={{
                                                        width: '720px',
                                                        padding: '8px',
                                                        borderRadius: '10px',
                                                        fontSize: '19px',
                                                        border: 'none',
                                                        color: 'white',
                                                        backgroundColor: '#9a9a9a',
                                                    }}
                                                >
                                                    SEND INVITE TO AGENTS
                                                </Button>
                                            </div>
                                        </>
                                    ) : LeadsDetails?.assign == 1 && LeadsDetails?.assignby?.id === LoginId ? (
                                        <>
                                            <div>
                                                <Card className={classes.card}>
                                                    <CardContent>
                                                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                            {/* right section */}
                                                            <div style={{ display: 'grid' }}>
                                                                <span style={{ fontSize: '12px', fontWeight: '500', color: 'white' }}>
                                                                    Assigned By
                                                                </span>
                                                                <span style={{ fontSize: '16px', color: 'white', fontWeight: '700' }}>
                                                                    {LeadsDetails?.assignby?.name}
                                                                </span>
                                                            </div>
                                                            {/* left section */}
                                                            <div style={{ display: 'grid' }}>
                                                                <div>
                                                                    <div style={{ display: 'flex', gap: '10px', marginLeft: '127px' }}>
                                                                        <div
                                                                            style={{
                                                                                background: 'white',
                                                                                height: '28px',
                                                                                borderRadius: '10px',
                                                                                padding: '2px',
                                                                            }}
                                                                        ></div>
                                                                        <img
                                                                            src={user_icon}
                                                                            alt=""
                                                                            style={{ width: '27px', height: '24px', borderRadius: '100px' }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div>
                                                                    <span style={{ color: 'white' }}>6 Feb 2024, 9.00 AM - 10.00 AM</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </CardContent>
                                                </Card>
                                            </div>
                                            <div style={{ marginTop: '12px' }}>
                                                <Button
                                                    onClick={() => {
                                                        navigate('/map');
                                                        dispatch(OPEN_INVITE_MODEL(LeadsDetails?.id));
                                                    }}
                                                    style={{
                                                        width: '720px',
                                                        padding: '8px',
                                                        borderRadius: '10px',
                                                        fontSize: '19px',
                                                        border: 'none',
                                                        color: 'white',
                                                        backgroundColor: 'gray',
                                                    }}
                                                >
                                                    VIEW INVITATION
                                                </Button>
                                            </div>
                                        </>
                                    ) : (
                                        <div style={{ marginTop: '6px' }}>
                                            <div>
                                                <span style={{ fontSize: '24px', fontWeight: 'bold', color: '#333' }}>Assignment Section</span>
                                            </div>
                                            {/* AssignBY section card */}
                                            <div>
                                                <Card
                                                    style={{
                                                        width: '720px',
                                                        height: '90px',
                                                        borderRadius: '22px',
                                                        background: 'rgb(240, 248, 255)',
                                                        boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                                    }}
                                                    className={classes.card}
                                                >
                                                    <CardContent>
                                                        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '5px' }}>
                                                            {/* Right section */}
                                                            <div style={{ display: 'grid' }}>
                                                                <span style={{ fontSize: '16px', fontWeight: '500', color: '#333' }}>
                                                                    Assigned By:{' '}
                                                                    <span style={{ fontSize: '14px', color: 'white', fontWeight: '400' }}>
                                                                        {LeadsDetails?.assignby?.name} {LeadsDetails?.assignby?.last_name}
                                                                    </span>
                                                                </span>
                                                                <span style={{ fontSize: '16px', fontWeight: '500', color: '#333' }}>
                                                                    Assigned To:{' '}
                                                                    <span style={{ fontSize: '14px', color: 'white', fontWeight: '400' }}>
                                                                        {LeadsDetails?.assignto?.name} {LeadsDetails?.assignto?.last_name}
                                                                    </span>{' '}
                                                                </span>
                                                            </div>
                                                            {/* Left section */}
                                                            {LeadsDetails?.status !== 'active' || LeadsDetails?.assignby?.id === LoginId ? (
                                                                <div style={{ display: 'grid' }}>
                                                                    <div style={{ display: 'flex', gap: '10px', marginLeft: '127px' }}>
                                                                        {!(
                                                                            LeadsDetails?.status === 'rejected' || LeadsDetails?.status === 'closed'
                                                                        ) && (
                                                                            <>
                                                                                <div
                                                                                    style={{
                                                                                        background: 'white',
                                                                                        height: '28px',
                                                                                        borderRadius: '10px',
                                                                                        padding: '2px',
                                                                                        border: '1px solid #119311',
                                                                                        display: 'flex',
                                                                                        alignItems: 'center',
                                                                                        cursor: 'pointer',
                                                                                    }}
                                                                                    onClick={() => handleClickNavigateModel(LeadsDetails)}
                                                                                >
                                                                                    <span
                                                                                        style={{
                                                                                            fontSize: '15px',
                                                                                            color: '#119311',
                                                                                            padding: '0 5px',
                                                                                        }}
                                                                                    >
                                                                                        Reassign
                                                                                    </span>
                                                                                </div>
                                                                                <Chip
                                                                                    onClick={handleClickOpenMeetingModel}
                                                                                    label="Edit Meeting"
                                                                                    icon={<EditIcon sx={{ color: 'white' }} />} // Apply the color here
                                                                                    sx={{
                                                                                        background: 'transparent',
                                                                                        border: '1px solid white',
                                                                                        borderRadius: '12px',
                                                                                        color: 'white',
                                                                                    }}
                                                                                />
                                                                            </>
                                                                        )}
                                                                        <img
                                                                            src={`https://iconnctapp.com/` + LeadsDetails?.assignto?.profile_image}
                                                                            alt=""
                                                                            style={{ width: '27px', height: '24px', borderRadius: '50%' }} // Ensure it's circular
                                                                        />
                                                                    </div>
                                                                    <div>
                                                                        <span style={{ color: '#666', fontSize: '14px' }}>
                                                                            {/* 6 Feb 2024, 9.00 AM - 10.00 AM */}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            ) : null}
                                                        </div>
                                                    </CardContent>
                                                </Card>
                                            </div>
                                        </div>
                                    )}
                                    {/* Notes */}
                                    <div style={{ display: 'grid', marginTop: '5px' }}>
                                        <div>
                                            <span style={{ color: '#606060', fontWeight: 'bold' }}>
                                                <NoteAltIcon />
                                                Notes
                                            </span>
                                        </div>

                                        <div>
                                            <Card
                                                style={{
                                                    width: '720px',
                                                    background: 'rgb(207 227 244)',
                                                    border: '3px solid #192ea669',
                                                    borderRadius: '12px',
                                                    padding: '3px',
                                                }}
                                            >
                                                {displayNotes.length > 0 && (
                                                    <>
                                                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                            <FilterListIcon
                                                                onClick={(e) => setMenuAnchor(e.currentTarget)}
                                                                sx={{ cursor: 'pointer' }}
                                                            />
                                                            <Menu
                                                                transformOrigin={{
                                                                    vertical: 'top',
                                                                    horizontal: 'right',
                                                                }}
                                                                anchorEl={menuAnchor}
                                                                open={Boolean(menuAnchor)}
                                                                onClose={() => setMenuAnchor(null)}
                                                            >
                                                                <MenuItem onClick={() => handleSort('asc')}>Ascending</MenuItem>
                                                                <MenuItem onClick={() => handleSort('desc')}>Descending</MenuItem>
                                                            </Menu>
                                                        </div>
                                                    </>
                                                )}
                                                <CardContent>
                                                    {displayNotes?.map((note, index) => {
                                                        // Ensure createTime exists and is valid before processing
                                                        if (note.createTime) {
                                                            // Split the createTime string into date and time components
                                                            const [datePart, timePart] = note.createTime.split('T');

                                                            // Extract year, month, and day from the date part
                                                            const [year, month, day] = datePart.split('-');

                                                            // Extract hour and minute from the time part
                                                            const [hour, minute] = timePart.substring(0, 5).split(':');

                                                            // Format date and time
                                                            const formattedDate = `${day}-${month}-${year}`;
                                                            const formattedTime = `${hour}:${minute}`;

                                                            // Combine date and time into desired format
                                                            const formattedCreateTime = `${formattedDate}  ${formattedTime}`;
                                                            const repliesToShow = showAllReplies ? note?.replies : note?.replies?.slice(0, 1);
                                                            return (
                                                                <div
                                                                    key={note.id ?? index}
                                                                    style={{
                                                                        marginBottom: '10px',
                                                                        display: 'grid',
                                                                        // gridTemplateColumns: '1fr auto',
                                                                        alignItems: 'center',
                                                                        background: 'white',
                                                                        borderRadius: '10px',
                                                                        padding: '10px',
                                                                    }}
                                                                >
                                                                    <div>
                                                                        <div style={{ color: '#000000b0', fontWeight: 'bold' }}>
                                                                            {note?.creatorName}
                                                                        </div>
                                                                        <div style={{ color: '#726b6b', gridColumn: '1 / span 2' }}>
                                                                            {note?.content}
                                                                        </div>
                                                                        <div style={{ color: '#726b6b', textAlign: 'right' }}>
                                                                            {formattedCreateTime}
                                                                        </div>
                                                                    </div>
                                                                    <div>
                                                                        {/* Display Replies */}
                                                                        {note?.replies?.length > 0 && (
                                                                            <div style={{ marginTop: '10px' }}>
                                                                                <span
                                                                                    style={{
                                                                                        marginTop: '5px',
                                                                                        color: '#007BFF',
                                                                                        background: 'none',
                                                                                        cursor: 'pointer',
                                                                                        fontSize: '14px',
                                                                                        fontWeight: 'bold',
                                                                                    }}
                                                                                >
                                                                                    Replies
                                                                                </span>
                                                                                {repliesToShow?.map((reply, replyIndex) => {
                                                                                    const [replyDatePart, replyTimePart] =
                                                                                        reply.created_at.split('T');
                                                                                    const [replyYear, replyMonth, replyDay] =
                                                                                        replyDatePart.split('-');
                                                                                    const [replyHour, replyMinute] = replyTimePart
                                                                                        .substring(0, 5)
                                                                                        .split(':');
                                                                                    const formattedReplyTime = `${replyDay}-${replyMonth}-${replyYear} ${replyHour}:${replyMinute}`;
                                                                                    return (
                                                                                        <div
                                                                                            key={reply?.id ?? replyIndex}
                                                                                            style={{ marginTop: '5px' }}
                                                                                        >
                                                                                            <div style={{ fontWeight: 'bold', color: '#444' }}>
                                                                                                {reply.creatorName}
                                                                                            </div>
                                                                                            <div style={{ color: '#555' }}>{reply.reply}</div>
                                                                                            <div style={{ fontSize: '12px', color: '#888' }}>
                                                                                                {formattedReplyTime}
                                                                                            </div>
                                                                                        </div>
                                                                                    );
                                                                                })}
                                                                                {/* Show More / Show Less Button */}
                                                                                {note?.replies?.length > 1 && (
                                                                                    <button
                                                                                        onClick={() => setShowAllReplies(!showAllReplies)}
                                                                                        style={{
                                                                                            marginTop: '5px',
                                                                                            color: '#007BFF',
                                                                                            background: 'none',
                                                                                            border: 'none',
                                                                                            cursor: 'pointer',
                                                                                            fontSize: '14px',
                                                                                            padding: '0',
                                                                                        }}
                                                                                    >
                                                                                        {showAllReplies ? 'Show Less' : 'Show More'}
                                                                                    </button>
                                                                                )}
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            );
                                                        } else {
                                                            // Handle the case where createTime is undefined or invalid
                                                            return (
                                                                <div
                                                                    key={note.id ?? index}
                                                                    style={{
                                                                        marginBottom: '10px',
                                                                        display: 'grid',
                                                                        gridTemplateColumns: '1fr auto',
                                                                        alignItems: 'center',
                                                                        background: 'white',
                                                                        borderRadius: '10px',
                                                                        padding: '10px',
                                                                    }}
                                                                >
                                                                    <div style={{ color: '#000000b0', fontWeight: 'bold' }}>{note?.creatorName}</div>
                                                                    <div style={{ color: '#726b6b', gridColumn: '1 / span 2' }}>{note?.content}</div>
                                                                    {/* <div style={{ color: '#726b6b', textAlign: 'right' }}>Invalid Date/Time</div> */}
                                                                </div>
                                                            );
                                                        }
                                                    })}
                                                </CardContent>
                                            </Card>
                                        </div>
                                    </div>
                                    {/* notes text field */}
                                    <div>
                                        <TextField
                                            fullWidth
                                            multiline
                                            placeholder="Enter notes here..."
                                            name="description"
                                            value={notes}
                                            onChange={(e) => setNotes(e.target.value)}
                                            rows={2}
                                            style={{
                                                fontSize: '14px',
                                                color: '#6E757C',
                                                marginTop: '2%',
                                                borderRadius: '12px', // Added border radius to TextField
                                                padding: '8px',
                                            }}
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    borderRadius: '12px',
                                                },
                                            }}
                                        />
                                    </div>
                                    {/* Add notes */}
                                    <div
                                        style={{
                                            marginTop: '10px',
                                            display: 'flex',
                                            justifyContent: 'center',
                                        }}
                                    >
                                        <Button
                                            onClick={() => handleAgentInternalNote(LeadsDetails?.id, notes)}
                                            style={{
                                                width: '696px',
                                                padding: '8px',
                                                borderRadius: '10px',
                                                fontSize: '19px',
                                                border: '1px solid #587DBF',
                                                backgroundColor: 'white',
                                                color: '#587DBF',
                                                marginBottom: '12px',
                                                transition: 'background-color 0.3s', // Smooth transition for hover
                                            }}
                                            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#e3f2fd')}
                                            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'white')}
                                        >
                                            Add Notes
                                        </Button>
                                    </div>
                                </div>
                            </DialogContent>
                        </BootstrapDialog>
                    )}
                </>
                {/*All invited and assign Leads   */}
                <Box display="flex" justifyContent="center" alignItems="center">
                    <Box display="flex" flexDirection="column" gap={3} width="100%" px={2}>
                        {/* Filter Dropdown */}

                        <Box display="flex" justifyContent="flex-end" style={{ gap: '10px' }}>
                            <Autocomplete
                                options={filterLeads}
                                getOptionLabel={(option) => option.label}
                                value={filterLeads?.find((option) => option.value === selectedFilterValue) || null}
                                onChange={(event, newValue) => setSelectedFilterValue(newValue?.value)}
                                sx={{ width: 300 }}
                                renderInput={(params) => <TextField {...params} label="Filter Leads" />}
                            />
                            <Box
                                style={{
                                    width: '66px',
                                    height: '55px',
                                    background: '#336a93',
                                    cursor: 'pointer',
                                    borderRadius: '10px',
                                }}
                            >
                                <Box position={'relative'}>
                                    <FilterListIcon
                                        style={{
                                            color: 'white',
                                            margin: '12px',
                                            fontSize: '41px',
                                        }}
                                        onClick={(e) => setMenuAnchorLeads(e.currentTarget)}
                                    />
                                    <Menu
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'right',
                                        }}
                                        anchorEl={menuAnchorLeads}
                                        open={Boolean(menuAnchorLeads)}
                                        onClose={() => setMenuAnchorLeads(null)}
                                    >
                                        <MenuItem onClick={() => handleSortLeads('asc')}>
                                            Ascending
                                            {sortOrderLeads === 'asc' ? (
                                                <>
                                                    <CheckIcon />
                                                </>
                                            ) : (
                                                ''
                                            )}
                                        </MenuItem>
                                        <MenuItem onClick={() => handleSortLeads('desc')}>
                                            Descending
                                            {sortOrderLeads === 'desc' ? (
                                                <>
                                                    <CheckIcon />
                                                </>
                                            ) : (
                                                ''
                                            )}
                                        </MenuItem>
                                    </Menu>
                                </Box>
                            </Box>
                        </Box>

                        {/* Lead Cards */}
                        {leads?.length === 0 ? (
                            <Typography variant="h6" align="center" fontWeight="bold">
                                No data found
                            </Typography>
                        ) : (
                            <Grid container spacing={2}>
                                {leads.map((data) => {
                                    const combinedDateTimeString = `${data?.lead?.date}T${data?.lead?.time}`;
                                    const userOffset = getUserOffset();
                                    const adjustedDate = adjustTimeBasedOnOffsetForReceivedData(combinedDateTimeString, userOffset);
                                    const formattedDate = formatDateTime(adjustedDate);
                                    const { formattedStatus, divStyle } = mapStatusToFormatAndColor(data?.lead?.status);

                                    return (
                                        <Grid item xs={12} sm={6} md={6} lg={4} key={data?.id}>
                                            <Card
                                                variant="outlined"
                                                sx={{
                                                    borderRadius: '22px',
                                                    cursor: 'pointer',
                                                    boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                                    transform: 'scale(1)', // Initial scale
                                                    transition: 'transform 0.3s ease-in-out', // Transition for smooth scaling
                                                }}
                                                onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.02)')} // Slight zoom on hover
                                                onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')} // Revert to original scale
                                                onClick={() => handleOpen(data?.lead?.id)}
                                            >
                                                <CardContent>
                                                    <Box display="flex" gap={2} flexDirection={{ xs: 'column', sm: 'row', md: 'row', lg: 'row' }}>
                                                        {/* Google Map Image */}
                                                        <Grid item xs={6} sm={6} md={6} lg={6}>
                                                            <Box position="relative" width="100%">
                                                                <img
                                                                    src={`https://maps.googleapis.com/maps/api/staticmap?zoom=${zoomLevel}&size=260x200&maptype=roadmap&center=${data?.lead?.buyer_latitude},${data?.lead?.buyer_longitude}&key=AIzaSyC9saN_UXZFij-RjWWX9drQEQSZw5PaPcA`}
                                                                    alt="Static map"
                                                                    style={{
                                                                        borderRadius: '18px',
                                                                        boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                                                        width: '100%',
                                                                        height: '100%',
                                                                    }}
                                                                />
                                                                <Box
                                                                    position="absolute"
                                                                    top="40%"
                                                                    left="40%"
                                                                    transform="translate(-50%, -50%)"
                                                                    zIndex={10}
                                                                    display="flex"
                                                                    alignItems="center"
                                                                    justifyContent="center"
                                                                >
                                                                    <img
                                                                        src={logo_between}
                                                                        alt="logo"
                                                                        style={{
                                                                            width: '44px',
                                                                            height: '44px',
                                                                            borderRadius: '50%',
                                                                            border: '1px solid gray',
                                                                        }}
                                                                    />
                                                                </Box>
                                                            </Box>
                                                        </Grid>

                                                        {/* Lead Details */}
                                                        <Grid item xs={6} sm={6} md={6} lg={6}>
                                                            <Box
                                                                display="flex"
                                                                flexDirection="column"
                                                                gap={1.5}
                                                                justifyContent="space-between"
                                                                mt={{ xs: 2, md: 0 }}
                                                            >
                                                                <Typography
                                                                    variant="h6"
                                                                    sx={{
                                                                        '&:hover': {
                                                                            color: '#375ea9',
                                                                            cursor: 'pointer',
                                                                        },
                                                                    }}
                                                                >
                                                                    {data?.lead?.first_name} {data?.lead?.last_name}
                                                                </Typography>

                                                                <Typography color="textSecondary" sx={{ fontSize: '14px' }}>
                                                                    📍 {data?.lead?.buyer_address}
                                                                </Typography>
                                                                <Typography color="textSecondary" sx={{ fontSize: '14px' }}>
                                                                    Assigned to: {data?.assignto?.name} {data?.assignto?.last_name}
                                                                </Typography>
                                                                {data?.lead?.date && (
                                                                    <Typography color="textSecondary" sx={{ fontSize: '14px' }}>
                                                                        📅 {formattedDate}
                                                                    </Typography>
                                                                )}
                                                                <Box>
                                                                    <span style={{ ...divStyle, borderRadius: '10px', padding: '4px' }}>
                                                                        {formattedStatus}
                                                                    </span>
                                                                </Box>
                                                            </Box>
                                                        </Grid>
                                                    </Box>
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                    );
                                })}
                            </Grid>
                        )}

                        {/* Pagination */}
                        <Box display="flex" justifyContent="flex-end" mt={2}>
                            <Pagination count={totalPages} color="primary" page={currentPage} onChange={(event, value) => setCurrentPage(value)} />
                        </Box>
                    </Box>
                </Box>

                {/* Required Notes if Change Status */}
                <Modal open={saveNoteModel} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                    <div
                        style={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            backgroundColor: '#fff',
                            padding: '20px',
                            borderRadius: '10px',
                            width: 'auto',
                            height: 'auto',
                            overflow: 'auto',
                        }}
                    >
                        <IconButton style={{ position: 'absolute', top: '0px', right: '20px' }} onClick={handleNoteModalClose}>
                            <CloseIcon />
                        </IconButton>
                        <Typography id="modal-modal-title" variant="h6" component="h2" style={{ fontWeight: 'bold' }}>
                            Add a reasons, why are you changing status to &quot;{formattedStatusValue}&quot;
                        </Typography>
                        <Typography id="modal-modal" component="h4" style={{ marginBottom: '10px', fontSize: '12px' }}>
                            Note: Please add DATE/TIME and Note
                        </Typography>
                        <div>
                            <TextField
                                fullWidth
                                multiline
                                // placeholder="Notes:"
                                name="description"
                                value={saveNoteStatus}
                                onChange={(e) => setSaveNoteModelStatus(e.target.value)}
                                rows={4}
                                style={{
                                    fontSize: '10px',
                                    color: '#6E757C',
                                    marginTop: '5%',
                                }}
                            />
                        </div>
                        {/* Add notes */}
                        <div style={{ marginTop: '10px' }}>
                            <Button
                                onClick={() => handleUpdateStatus(updateStatusValue)}
                                style={{
                                    width: '720px',
                                    padding: '8px',
                                    borderRadius: '10px',
                                    fontSize: '19px',
                                    border: ' 1px solid #587DBF',
                                    backgroundColor: 'white',
                                    color: '#587DBF',
                                }}
                            >
                                ADD
                            </Button>
                        </div>
                    </div>
                </Modal>

                <UpdateIcaMeeting
                    openMeetingModal={openMeetingModal}
                    setOpenMeetingModal={setOpenMeetingModal}
                    leadMeetingId={LeadsDetails?.id}
                    leadAddress={LeadsDetails?.display_address}
                    buyerLatitude={LeadsDetails?.buyer_latitude}
                    buyerLongitude={LeadsDetails?.buyer_longitude}
                    leadDate={LeadsDetails?.date}
                    leadTime={LeadsDetails?.time}
                />
            </ThemeProvider>
            <LogoutExpiredModal setLogOutModal={setLogOutModal} logOutModal={logOutModal} />
        </Container>
    );
};

export default ICALEADS;
